import { Button } from "ui/Button";
import { useI18n } from "utils/with-i18n.utils";

type ArticleProps = {
  title: string;
  description: string;
  link: string;
  img: React.DetailedHTMLProps<
    React.ImgHTMLAttributes<HTMLImageElement>,
    HTMLImageElement
  >["src"];
  date: string;
};

export const Article = ({
  title,
  description,
  link,
  img,
  date,
}: ArticleProps) => {
  const i18n = useI18n();

  return (
    <div className="flex flex-col gap-8 items-center py-8 px-12 text-center rounded-[18px] border-[1px] border-[#0000004D] md:flex-row md:gap-20 md:text-left">
      <div className="flex justify-center max-w-[60%] md:min-w-[163px]">
        <img src={img} alt={title} />
      </div>

      <div>
        <p className="py-0.5 px-4 mx-auto mb-3 w-fit text-cornflower-blue bg-[#7D89FF33] rounded-full md:mx-0">
          {date}
        </p>

        <div className="flex flex-col gap-6">
          <h2 className="text-2xl font-bold md:text-3xl">{title}</h2>
          <p className="text-base">{description}</p>
          <a href={link} target="_blank">
            <Button className="w-fit">
              {i18n.t("press.button")}
            </Button>
          </a>
        </div>
      </div>
    </div>
  );
};
